import useSWRImmutable from "swr/immutable";
import useAuthenticatedAxios from "./use-authenticated-axios";
import { useMemo } from "react";

import useAuth from "./use-auth.js";

export default function useStripePrices(type, options = {}) {
  const { auth } = useAuth();
  const axios = useAuthenticatedAxios();
  const fallbackData = useMemo(() => [], []);
  const { params } = options;
  const {
    data: prices,
    error,
    isLoading,
  } = useSWRImmutable(
    ["/stripe/prices", type, params, auth.userId],
    ([url, type, params]) => {
      return axios
        .get(url, { params: { type, ...params } })
        .then((res) => res.data);
    },
  );

  return {
    prices: prices || fallbackData,
    error,
    isLoading,
  };
}

export function useStripeComptaPrice(propertyIds, folderIds, fiscalYear) {
  const axios = useAuthenticatedAxios();
  const { data, ...rest } = useSWRImmutable(
    propertyIds.length + folderIds.length === 0
      ? null
      : ["/stripe/comptabilite", propertyIds, folderIds, fiscalYear],
    ([url, propertyIds, folderIds]) => {
      return axios
        .post(url, {
          property_ids: propertyIds,
          folder_ids: folderIds,
          fiscal_year: fiscalYear,
        })
        .then((res) => res.data);
    },
  );

  return {
    comptaPriceDetails: data || [],
    ...rest,
  };
}

export function useStripeAbonnementPrice(priceId, nbBiens) {
  const axios = useAuthenticatedAxios();

  const { data, error, isLoading } = useSWRImmutable(
    priceId ? [priceId, nbBiens] : null,
    ([priceId, nbBiens]) => {
      return axios
        .get(`/stripe/abonnements/${priceId}`, {
          params: { nb_biens: nbBiens },
        })
        .then((res) => res.data);
    },
  );

  return {
    price: data,
    error,
    isLoading,
  };
}
export function useAllStripePrices() {
  const axios = useAuthenticatedAxios();

  const { data, error, isLoading } = useSWRImmutable("prices", () =>
    axios.get(`/stripe/abonnements`).then((res) => res.data),
  );

  return {
    pricesByNbBiens: data,
    error,
    isLoading,
  };
}

export function useAdminStripePrices() {
  const axios = useAuthenticatedAxios();

  const { data, error, isLoading } = useSWRImmutable(
    "/stripe/prices/admin",
    (url) => axios.get(url).then((res) => res.data),
  );

  return {
    pricesByType: data || {},
    error,
    isLoading,
  };
}
